import React, { useRef } from 'react';
import { AttachFileIcon } from '../../../../assets';

interface FileUploadProps {
  as?: React.ReactNode;
  className?: string;
  inputClassName?: string;
  title?: string;
  placeholder?: string;
  placeholderClassName?: string;
  name?: string;
  onChange?: any;
  accept?: string;
}

const FileUpload: React.FC<FileUploadProps> = ({
  as,
  placeholder = "Insérez un fichier (facultatif)",
  placeholderClassName,
  onChange,
  className,
  title = "Choisir un fichier",
  inputClassName,
  accept,
  name,
  ...rest
}) => {
  const fileInputRef = useRef<HTMLInputElement>(null); // Unique reference

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      console.log("Selected file:", file, name);
      if (name) {
        onChange?.({
          target: {
            name,
            value: { name: file.name, file },
          },
        });
      } else {
        onChange?.(file);
      }
    }
  };

  const handleClick = () => {
    fileInputRef.current?.click(); 
  };

  return (
    <div className={`${as ? '' : `flex items-center bg-white rounded-full p-1 ${className}`}`}>
      <input
        type="file"
        ref={fileInputRef} 
        accept={accept}
        onChange={handleFileChange}
        className="hidden"
      />
      {as ? (
        React.cloneElement(as as React.ReactElement, { onClick: handleClick })
      ) : (
        <>
          <div
            className={`${as ? '' : `flex items-center bg-[#E4E4EA] text-primary-blue text-nowrap px-4 rounded-full font-medium h-[50px] shadow-sm cursor-pointer mr-2 ${inputClassName}`}`}
            onClick={handleClick}
          >
            <div className="space-x-2 flex">
              <img src={AttachFileIcon} alt="" />
              <div className="text-sm">{title}</div>
            </div>
          </div>
          <span className={`text-[#6F6F6F] font-light text-nowrap text-ellipsis overflow-hidden ${placeholderClassName}`}>
            {placeholder}
          </span>
        </>
      )}
    </div>
  );
};

export default FileUpload;
